module.exports = __webpack_public_path__ + "static/media/colourants.79fd329f.png";